export default __webpack_public_path__ + "static/media/309.b7c9b75e.jpg";